import React from 'react';
import { Alert } from '@mui/material';
import { AppContext } from 'src/store/ContextStore';
import { isAnonymousActive } from './anonymousPedigrees';
import { useAutoTranslation } from 'src/hooks/useTranslate';

// Persistent warning shown on free-text fields while Anonymous Pedigrees is
// active. Free text cannot be policed mechanically (plan §2 non-goals), so the
// banner + training is the control. Renders nothing when the mode is off, so
// hosts can place it unconditionally above their input.
export default function AnonymousFreeTextBanner({ sx }) {
  const t = useAutoTranslation();

  // AppContext defaults to null (no Provider). Guard so hosts can render this
  // unconditionally without being wrapped in an AppContext.Provider.
  const { content } = React.useContext(AppContext) ?? {};
  const pedigreeSetting = content?.settings?.pedigreeSetting;

  if (!isAnonymousActive(pedigreeSetting)) return null;

  return (
    <Alert severity="warning" sx={{ fontSize: 12, py: 0.25, ...sx }}>
      {t(
        'Anonymous pedigrees is enabled — do not enter patient-identifying information (names, dates of birth, addresses, identifiers) in free text.'
      )}
    </Alert>
  );
}
